/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VimePlayground, VimeAudio, VimeFile, VimeCaptionControl, VimeControl, VimeIcon, VimeTooltip, VimeCaptions, VimeClickToPlay, VimeControlGroup, VimeControlSpacer, VimeControls, VimeCurrentTime, VimeTime, VimeDailymotion, VimeEmbed, VimeDash, VimeVideo, VimeDblClickFullscreen, VimeDefaultControls, VimeEndTime, VimeFullscreenControl, VimeLiveIndicator, VimeMuteControl, VimePipControl, VimePlaybackControl, VimeScrim, VimeScrubberControl, VimeSlider, VimeSettingsControl, VimeTimeProgress, VimeVolumeControl, VimeDefaultSettings, VimeMenu, VimeMenuItem, VimeMenuRadio, VimeMenuRadioGroup, VimeSettings, VimeSubmenu, VimeDefaultUi, VimeIcons, VimePoster, VimeSkeleton, VimeSpinner, VimeUi, VimeHls, VimePlayer, VimeVimeo, VimeYoutube } from '@vime/core';
import { define } from '../lib';
define('vime-playground', VimePlayground);
define('vime-audio', VimeAudio);
define('vime-file', VimeFile);
define('vime-caption-control', VimeCaptionControl);
define('vime-control', VimeControl);
define('vime-icon', VimeIcon);
define('vime-tooltip', VimeTooltip);
define('vime-captions', VimeCaptions);
define('vime-click-to-play', VimeClickToPlay);
define('vime-control-group', VimeControlGroup);
define('vime-control-spacer', VimeControlSpacer);
define('vime-controls', VimeControls);
define('vime-current-time', VimeCurrentTime);
define('vime-time', VimeTime);
define('vime-dailymotion', VimeDailymotion);
define('vime-embed', VimeEmbed);
define('vime-dash', VimeDash);
define('vime-video', VimeVideo);
define('vime-dbl-click-fullscreen', VimeDblClickFullscreen);
define('vime-default-controls', VimeDefaultControls);
define('vime-end-time', VimeEndTime);
define('vime-fullscreen-control', VimeFullscreenControl);
define('vime-live-indicator', VimeLiveIndicator);
define('vime-mute-control', VimeMuteControl);
define('vime-pip-control', VimePipControl);
define('vime-playback-control', VimePlaybackControl);
define('vime-scrim', VimeScrim);
define('vime-scrubber-control', VimeScrubberControl);
define('vime-slider', VimeSlider);
define('vime-settings-control', VimeSettingsControl);
define('vime-time-progress', VimeTimeProgress);
define('vime-volume-control', VimeVolumeControl);
define('vime-default-settings', VimeDefaultSettings);
define('vime-menu', VimeMenu);
define('vime-menu-item', VimeMenuItem);
define('vime-menu-radio', VimeMenuRadio);
define('vime-menu-radio-group', VimeMenuRadioGroup);
define('vime-settings', VimeSettings);
define('vime-submenu', VimeSubmenu);
define('vime-default-ui', VimeDefaultUi);
define('vime-icons', VimeIcons);
define('vime-poster', VimePoster);
define('vime-skeleton', VimeSkeleton);
define('vime-spinner', VimeSpinner);
define('vime-ui', VimeUi);
define('vime-hls', VimeHls);
define('vime-player', VimePlayer);
define('vime-vimeo', VimeVimeo);
define('vime-youtube', VimeYoutube);
export default Vue.extend({
    props: {
        provider: {},
        src: {},
        showCustomUI: {},
        theme: {},
        poster: {},
    },
    methods: {},
    render: render('vime-playground', []),
});
//# sourceMappingURL=VimePlayground.js.map